import { ArrowRight, ChevronDown, Code, Briefcase, Mail } from 'lucide-react';

export default function Hero() {
  return (
    <section id="hero" className="hero-overlap-layout">
      <div className="hero-container">
        {/* Left Image Card */}
        <div className="hero-image-card reveal visible">
          <img src="/bedb805e-569e-4785-9034-4c78f6463a4a.png" alt="Yassine ALAOUI — Developer Engineer" style={{ objectPosition: 'center 20%' }} />
          <div className="hero-image-overlay" />
        </div>

        {/* Right Floating Text Card */}
        <div className="hero-text-card reveal visible" style={{ transitionDelay: '0.2s' }}>
          <p className="hero-eyebrow">Ingénieur d'état en informatique</p>
          <h1 className="hero-name">
            Yassine<span>ALAOUI</span>
          </h1>
          <p className="hero-title">
            React · Node.js · AI · LLMs · Agents Intelligents &nbsp;|&nbsp; Casablanca, Maroc
          </p>
          <p className="hero-desc">
            Passionné par la création d'applications web intelligentes propulsées
            par l'IA. J'oriente mes projets vers les agents intelligents, le machine
            learning et les solutions innovantes qui transforment l'expérience utilisateur.
          </p>
          <div className="hero-buttons">
            <a className="btn-primary" href="#projects">Voir mes projets <ArrowRight size={18} /></a>
            <a className="btn-outline" href="#contact">Discutons <Mail size={18} /></a>
          </div>
          
          <div className="hero-socials-horizontal">
            <a className="social-link-horiz flex items-center gap-2" href="https://www.linkedin.com/in/yassine-alaoui-0a42a9243/" target="_blank" rel="noreferrer">
              <Briefcase size={18} /> LinkedIn
            </a>
            <a className="social-link-horiz flex items-center gap-2" href="https://github.com/Yassine-ALAOUI-a11" target="_blank" rel="noreferrer">
              <Code size={18} /> GitHub
            </a>
          </div>
        </div>
      </div>
      <div className="hero-scroll-hint">
        Défiler <ChevronDown size={14} />
      </div>
    </section>
  );
}
